"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatKetteJson = exports.ketteJson = void 0;
const fuehrungsrinne_typ_1 = require("../fuehrungsrinne/fuehrungsrinne-typ");
const KetteSerieType_1 = require("./KetteSerieType");
exports.ketteJson = {
    KetteSerieType: KetteSerieType_1.KetteSerieType.default,
    LangerWeg: true,
    Einspeisung: 1,
    Versatz: { Unit: 'mm', Value: 0 },
    MinDistKlemmO: { Unit: 'mm', Value: 0 },
    MinDistKlemmU: { Unit: 'mm', Value: 0 },
    MinDistO: { Unit: 'mm', Value: 0 },
    MinDistU: { Unit: 'mm', Value: 0 },
    RastPosDist: { Unit: 'mm', Value: 1 },
    RastPosLeft: { Unit: 'mm', Value: 0 },
    Id: 4817,
    ArtNr: { DE: '3400.150.150.0', US: '3400-150-150-0' },
    ArtNrExists: true,
    ArtNrGenerated: '3400.150.150.0',
    Bezeichnung: {
        'de-DE': 'e-kette® Serie 3400',
        'hu-HU': 'E-Chains® 3400 Széria',
        'en-US': 'Energy chain® Series 3400',
        'zh-TW': '3400系列拖鏈',
        'ko-KR': 'E-Chain® 3400 시리즈',
        'es-ES': 'E-Chains® Serie 3400',
        'zh-CN': '3400系列拖链',
        'it-IT': 'Catena portacavi serie 3400',
        'pl-PL': 'E-Chains® Seria 3400',
        'pt-PT': 'Calhas articuladas da Série 3400',
        'nl-NL': 'Kabelrupsen Series 3400',
        'sv-SE': 'E-kedja serie 3400',
        'da-DK': 'E-Kæde -serie 3400',
        'cs-CZ': 'e-chain® série 3400',
        'fr-FR': 'Chaîne Série 3400',
        'en-GB': 'e-chain® Series 3400',
        'ja-JP': 'エナジーチェーン 3400型',
    },
    ReferenceKetteJson: {
        SerieRef: { Kuerzel: '3400', Id: 4777 },
        FreitragenderBetriebErlaubt: true,
        K2: { Value: 1005, Unit: 'mm' },
        GewichtKgProM: { Value: 2.17, Unit: 'kg_m' },
        NoSeparaterFootTop: true,
        Aussenbreite: { Value: 170, Unit: 'mm' },
        Teilung: { Value: 67, Unit: 'mm' },
        Halbstegig: false,
        ArtSerieBreite: '3400.150',
        IndexBreite: '150',
        LeitungDiameterMax: { Value: 42, Unit: 'mm' },
        StandardTrennstegArtNr: '45.1.1',
        Innenbreite: { Value: 150, Unit: 'mm' },
        IndexBiegeradius: '150',
        K: { Value: 610, Unit: 'mm' },
        Aussenhoehe: { Value: 64, Unit: 'mm' },
        Biegeradius: { Value: 150, Unit: 'mm' },
        ArtNr: { DE: '3400.150.150.0', US: '3400-150-150-0' },
        UngeradeAnzahlGlieder: false,
        Bauform: 'Kette',
        GleitenderBetriebErlaubt: true,
        Id: 4817,
        Innenhoehe: { Value: 45, Unit: 'mm' },
        VersatzFestpunktErlaubt: true,
        Bezeichnung: {
            'de-DE': 'e-kette® Serie 3400',
            'hu-HU': 'E-Chains® 3400 Széria',
            'en-US': 'Energy chain® Series 3400',
            'zh-TW': '3400系列拖鏈',
            'ko-KR': 'E-Chain® 3400 시리즈',
            'es-ES': 'E-Chains® Serie 3400',
            'zh-CN': '3400系列拖链',
            'it-IT': 'Catena portacavi serie 3400',
            'pl-PL': 'E-Chains® Seria 3400',
            'pt-PT': 'Calhas articuladas da Série 3400',
            'nl-NL': 'Kabelrupsen Series 3400',
            'sv-SE': 'E-kedja serie 3400',
            'da-DK': 'E-Kæde -serie 3400',
            'cs-CZ': 'e-chain® série 3400',
            'fr-FR': 'Chaîne Série 3400',
            'en-GB': 'e-chain® Series 3400',
            'ja-JP': 'エナジーチェーン 3400型',
        },
    },
    SerieRef: { Id: 4777, Kuerzel: '3400' },
    IndexBreite: '150',
    IndexBiegeradius: '150',
    ArtSerieBreite: '3400.150',
    GleitenderBetriebErlaubt: true,
    UngeradeAnzahlGlieder: false,
    VersatzFestpunktErlaubt: true,
    Teilung: { Unit: 'mm', Value: 67 },
    Aussenhoehe: { Unit: 'mm', Value: 64 },
    Innenhoehe: { Unit: 'mm', Value: 45 },
    Biegeradius: { Unit: 'mm', Value: 150 },
    Aussenbreite: { Unit: 'mm', Value: 170 },
    Innenbreite: { Unit: 'mm', Value: 150 },
    K: { Unit: 'mm', Value: 610 },
    K2: { Unit: 'mm', Value: 1005 },
    GewichtKgProM: { Unit: 'kg_m', Value: 2.17 },
    LeitungDiameterMax: { Unit: 'mm', Value: 42 },
    Halbstegig: true,
    Bauform: 'Kette',
    Color: '0',
    EffektiveLaenge: { Unit: 'mm', Value: 2010 },
    EffektiveLaengeWithAEs: { Unit: 'mm', Value: 2164 },
    Laenge: { Unit: 'mm', Value: 2005 },
    NumGlieder: 30,
    Verfahrweg: { Unit: 'mm', Value: 2000 },
    NoSeparaterFootTop: true,
    StandardTrennstegArtNr: '45.1.1',
    StaticIAArtikelRef: [],
    EntityId: '1508923396600_22996',
    IsMontageMitnehmer: false,
    MinBauraumGleitendRinneRefs: [
        {
            FuehrungsrinneId: 123,
            FuehrungsrinneTyp: fuehrungsrinne_typ_1.FuehrungsrinneTyp.SuperAlu,
            FuehrungsrinneStuecklaenge: { Value: 55, Unit: 'mm' },
            FuehrungsrinneStuecklaenge_mm: 55,
            MontageSetId: 456,
            Breite: { Value: 11, Unit: 'mm' },
            Breite_mm: 11,
            Hoehe: { Value: 33, Unit: 'mm' },
            Hoehe_mm: 33,
        },
        {
            FuehrungsrinneId: 123 + 1,
            FuehrungsrinneTyp: fuehrungsrinne_typ_1.FuehrungsrinneTyp.Stahl,
            FuehrungsrinneStuecklaenge: { Value: 55 + 1, Unit: 'mm' },
            FuehrungsrinneStuecklaenge_mm: 55 + 1,
            MontageSetId: 456 + 1,
            Breite: { Value: 11 + 1, Unit: 'mm' },
            Breite_mm: 11 + 1,
            Hoehe: { Value: 33 + 1, Unit: 'mm' },
            Hoehe_mm: 33 + 1,
        },
        {
            FuehrungsrinneId: 123 + 2,
            FuehrungsrinneTyp: fuehrungsrinne_typ_1.FuehrungsrinneTyp.SuperAlu,
            FuehrungsrinneStuecklaenge: { Value: 55 + 2, Unit: 'mm' },
            FuehrungsrinneStuecklaenge_mm: 55 + 2,
            MontageSetId: 456 + 2,
            Breite: { Value: 11 + 2, Unit: 'mm' },
            Breite_mm: 11 + 2,
            Hoehe: { Value: 33 + 2, Unit: 'mm' },
            Hoehe_mm: 33 + 2,
        },
    ],
};
exports.flatKetteJson = {
    KetteSerieType: KetteSerieType_1.KetteSerieType.default,
    LangerWeg: true,
    Einspeisung: 1,
    Versatz_mm: 0,
    MinDistKlemmO_mm: 0,
    MinDistKlemmU_mm: 0,
    MinDistO_mm: 0,
    MinDistU_mm: 0,
    RastPosDist_mm: 1,
    RastPosLeft_mm: 0,
    Id: 4817,
    ArtNr: { DE: '3400.150.150.0', US: '3400-150-150-0' },
    ArtNrExists: true,
    ArtNrGenerated: '3400.150.150.0',
    Bezeichnung: {
        'de-DE': 'e-kette® Serie 3400',
        'hu-HU': 'E-Chains® 3400 Széria',
        'en-US': 'Energy chain® Series 3400',
        'zh-TW': '3400系列拖鏈',
        'ko-KR': 'E-Chain® 3400 시리즈',
        'es-ES': 'E-Chains® Serie 3400',
        'zh-CN': '3400系列拖链',
        'it-IT': 'Catena portacavi serie 3400',
        'pl-PL': 'E-Chains® Seria 3400',
        'pt-PT': 'Calhas articuladas da Série 3400',
        'nl-NL': 'Kabelrupsen Series 3400',
        'sv-SE': 'E-kedja serie 3400',
        'da-DK': 'E-Kæde -serie 3400',
        'cs-CZ': 'e-chain® série 3400',
        'fr-FR': 'Chaîne Série 3400',
        'en-GB': 'e-chain® Series 3400',
        'ja-JP': 'エナジーチェーン 3400型',
    },
    ReferenceKetteJson: {
        SerieRef: { Kuerzel: '3400', Id: 4777 },
        FreitragenderBetriebErlaubt: true,
        K2: { Value: 1005, Unit: 'mm' },
        GewichtKgProM: { Value: 2.17, Unit: 'kg_m' },
        NoSeparaterFootTop: true,
        Aussenbreite: { Value: 170, Unit: 'mm' },
        Teilung: { Value: 67, Unit: 'mm' },
        Halbstegig: false,
        ArtSerieBreite: '3400.150',
        IndexBreite: '150',
        LeitungDiameterMax: { Value: 42, Unit: 'mm' },
        StandardTrennstegArtNr: '45.1.1',
        Innenbreite: { Value: 150, Unit: 'mm' },
        IndexBiegeradius: '150',
        K: { Value: 610, Unit: 'mm' },
        Aussenhoehe: { Value: 64, Unit: 'mm' },
        Biegeradius: { Value: 150, Unit: 'mm' },
        ArtNr: { DE: '3400.150.150.0', US: '3400-150-150-0' },
        UngeradeAnzahlGlieder: false,
        Bauform: 'Kette',
        GleitenderBetriebErlaubt: true,
        Id: 4817,
        Innenhoehe: { Value: 45, Unit: 'mm' },
        VersatzFestpunktErlaubt: true,
        Bezeichnung: {
            'de-DE': 'e-kette® Serie 3400',
            'hu-HU': 'E-Chains® 3400 Széria',
            'en-US': 'Energy chain® Series 3400',
            'zh-TW': '3400系列拖鏈',
            'ko-KR': 'E-Chain® 3400 시리즈',
            'es-ES': 'E-Chains® Serie 3400',
            'zh-CN': '3400系列拖链',
            'it-IT': 'Catena portacavi serie 3400',
            'pl-PL': 'E-Chains® Seria 3400',
            'pt-PT': 'Calhas articuladas da Série 3400',
            'nl-NL': 'Kabelrupsen Series 3400',
            'sv-SE': 'E-kedja serie 3400',
            'da-DK': 'E-Kæde -serie 3400',
            'cs-CZ': 'e-chain® série 3400',
            'fr-FR': 'Chaîne Série 3400',
            'en-GB': 'e-chain® Series 3400',
            'ja-JP': 'エナジーチェーン 3400型',
        },
    },
    SerieRef: { Id: 4777, Kuerzel: '3400' },
    IndexBreite: '150',
    IndexBiegeradius: '150',
    ArtSerieBreite: '3400.150',
    GleitenderBetriebErlaubt: true,
    UngeradeAnzahlGlieder: false,
    VersatzFestpunktErlaubt: true,
    Teilung_mm: 67,
    Aussenhoehe_mm: 64,
    Innenhoehe_mm: 45,
    Biegeradius_mm: 150,
    Aussenbreite_mm: 170,
    Innenbreite_mm: 150,
    K_mm: 610,
    K2_mm: 1005,
    GewichtKgProM_kg_m: 2.17,
    LeitungDiameterMax_mm: 42,
    Halbstegig: true,
    Bauform: 'Kette',
    Color: '0',
    EffektiveLaenge_mm: 2010,
    EffektiveLaengeWithAEs_mm: 2164,
    Laenge_mm: 2005,
    NumGlieder: 30,
    Verfahrweg_mm: 2000,
    NoSeparaterFootTop: true,
    StandardTrennstegArtNr: '45.1.1',
    StaticIAArtikelRef: [],
    EntityId: '1508923396600_22996',
    IsMontageMitnehmer: false,
    MinBauraumGleitendRinneRefs: [
        {
            FuehrungsrinneId: 123,
            FuehrungsrinneTyp: fuehrungsrinne_typ_1.FuehrungsrinneTyp.SuperAlu,
            FuehrungsrinneStuecklaenge_mm: 55,
            MontageSetId: 456,
            Breite_mm: 11,
            Hoehe_mm: 33,
        },
        {
            FuehrungsrinneId: 123 + 1,
            FuehrungsrinneTyp: fuehrungsrinne_typ_1.FuehrungsrinneTyp.Stahl,
            FuehrungsrinneStuecklaenge_mm: 55 + 1,
            MontageSetId: 456 + 1,
            Breite_mm: 11 + 1,
            Hoehe_mm: 33 + 1,
        },
        {
            FuehrungsrinneId: 123 + 2,
            FuehrungsrinneTyp: fuehrungsrinne_typ_1.FuehrungsrinneTyp.SuperAlu,
            FuehrungsrinneStuecklaenge_mm: 55 + 2,
            MontageSetId: 456 + 2,
            Breite_mm: 11 + 2,
            Hoehe_mm: 33 + 2,
        },
    ],
};
//# sourceMappingURL=ketteJson.js.map